export default "__VITE_ASSET__BMCtcpb___"